<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/walletindex' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>钱包</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>账期应付明细</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item" id="auto-0">
          <span class="item-label">账单日期</span>
          <el-date-picker
            v-model="tableOptions.startTime"
            type="datetime"
            placeholder="选择开始时间"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
          <span>-</span>
          <el-date-picker
            v-model="tableOptions.endTime"
            type="datetime"
            placeholder="选择结束时间"
            default-time="23:59:59"
            :clearable="false"
            value-format="timestamp"
            :picker-options="pickerTime"
          >
          </el-date-picker>
        </div>
        <div class="toolbar-item">
          <el-button type="primary" size="small" @click="screen" id="auto-1">筛选</el-button>
          <el-button type="primary" size="small" @click="exportList" id="auto-2">导出表格</el-button>
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-3">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        ref="tableData"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
        @row-click="selectRow"
      >
        <!-- 合计应付金额 -->
        <template #resultMoney="{ scope }">
          <span class="font-orange">{{ scope.row.resultMoney | thousands(2) }}元</span>
        </template>
        <!-- 逾期情况 -->
        <template #overDaysStr="{ scope }">
          <span v-if="scope.row.overDays < -7">{{ scope.row.overDays * -1 }}天后到期</span>
          <span v-else-if="-7 <= scope.row.overDays && scope.row.overDays <= -1" class="font-orange"
            >{{ scope.row.overDays * -1 }}天后到期</span
          >
          <span v-else-if="scope.row.overDays == 0" class="font-red">今日到期</span>
          <span v-else class="font-red">已逾期{{ scope.row.overDays }}天</span>
        </template>
        <!-- 账期服务费 -->
        <template #paymentDaysFee="{ scope }">
          <span class="font-orange">{{ scope.row.paymentDaysFee | thousands(2) }}元</span>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:3
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import dateLimit from '@/api/dateLimit';
import tableMixin from '@/utils/tableMixin';
export default {
  name: 'ActperiodList',
  mixins: [tableMixin],
  data: function () {
    return {
      columns: [
        { label: '合计应付金额', prop: 'resultMoney', 'min-width': 120 },
        { label: '运单数合计', prop: 'detailCount', 'min-width': 120 },
        { label: '应付到期日', prop: 'expiredTimeStr', 'min-width': 120 },
        { label: '逾期情况', prop: 'overDaysStr', 'min-width': 120 },
        { label: '账期服务费', prop: 'paymentDaysFee', 'min-width': 120 }
      ],
      axiosConfig: { url: api.laterPayResultQueryCompanyExpendList }, // 列表接口
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      },
      tableOptions: {
        startTime: new Date(dateLimit.getThreeMonth()).getTime(),
        endTime: dateLimit.currentDayEnd.getTime()
      } //筛选条件
    };
  },
  methods: {
    //筛选查询
    screen() {
      if (!WUYI.checkDate(this.tableOptions.startTime, this.tableOptions.endTime)) return;
      this.handleSearch();
    },
    // 导出表格
    async exportList() {
      if (this.tableData.length == 0) {
        this.$message.error('没有需要导出的数据');
        return;
      }
      await axios.post(api.laterPayResultQueryCompanyExpendListExport, this.tableOptions);
      this.$message.success('导出成功,请在下载中心查看');
    },
    selectRow(row, event, col) {
      this.$router.push({
        path: '/actpListdetail',
        query: { startTime: row.beginTime, endTime: row.endTime, expiredTime: row.expiredTime }
      });
    }
  }
};
</script>
